import React, { Suspense } from "react";
import { Helmet } from "react-helmet";
import Slider from "../components/Slider/Slider";
import ServiceHomePage from "../components/ServiceHomePage/ServiceHomePage";
import About from "../components/About/About";

// Lazy-loaded sections
const Project = React.lazy(() => import("../components/Project/Project"));
const Blog = React.lazy(() => import("../Blog/Blog"));
const ClintReview = React.lazy(() => import("../ClintReview/ClintReview"));
const WeWorkWith = React.lazy(() => import("../WeWorkWith/WeWorkWith"));

const DOMAIN = "https://skylinebussiness.com"; // ✅ change to your real domain

const Home = () => {
  return (
    <>
      {/* ✅ SEO META */}
      <Helmet>
        <title>Skyline Bussiness Solutions | Web Development, SEO & Digital Marketing</title>

        <meta
          name="description"
          content="Skyline Bussiness Solutions offers web development, SEO, digital marketing, branding, and software solutions to grow your business online."
        />

        <meta name="robots" content="index, follow" />

        {/* ✅ Canonical */}
        <link rel="canonical" href={DOMAIN} />

        {/* ✅ Open Graph */}
        <meta property="og:title" content="Skyline Bussiness Solutions" />
        <meta
          property="og:description"
          content="Professional IT services including web development, SEO, and digital marketing."
        />
        <meta property="og:url" content={DOMAIN} />
        <meta property="og:type" content="website" />

        {/* ✅ Schema (Organization) */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Organization",
            "name": "Skyline Business Solutions",
            "url": DOMAIN,
            "logo": `${DOMAIN}/logo.png`,
            "sameAs": [
              "https://instagram.com",
              "https://linkedin.com",
              "https://x.com"
            ]
          })}
        </script>
      </Helmet>

      <main>

        {/* HERO */}
        <section aria-label="Homepage Hero">
          <Slider />
        </section>

        {/* SERVICES */}
        <section aria-label="Our Services">
          <ServiceHomePage />
        </section>

        {/* ABOUT */}
        <section aria-label="About Skyline Bussiness Solutions">
          <About />
        </section>

        {/* PROJECTS */}
        <section aria-label="Our Projects">
          <Suspense fallback={<div className="loader">Loading Projects...</div>}>
            <Project />
          </Suspense>
        </section>

        {/* REVIEWS */}
        <section aria-label="Client Reviews">
          <Suspense fallback={<div className="loader">Loading Reviews...</div>}>
            <ClintReview />
          </Suspense>
        </section>

        {/* BLOG */}
        <section aria-label="Latest Blog Posts">
          <Suspense fallback={<div className="loader">Loading Blog...</div>}>
            <Blog />
          </Suspense>
        </section>

        {/* PARTNERS */}
        <section aria-label="Companies We Work With">
          <Suspense fallback={<div className="loader">Loading Partners...</div>}>
            <WeWorkWith />
          </Suspense>
        </section>

      </main>
    </>
  );
};

export default Home;